import React from 'react';
import { motion } from 'framer-motion';
import { PillIcon, ArrowRightIcon, HelpCircleIcon, ActivityIcon } from 'lucide-react';
export function TumourVisibilityComparison() {
  return <div className="w-full py-4 flex flex-col space-y-6" data-id="element-251">
      <div className="grid grid-cols-2 gap-4" data-id="element-252">
        {/* Left Panel: Indirect */}
        <motion.div initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col items-center text-center" data-id="element-253">
          <div className="flex items-center justify-center space-x-2 mb-4 h-12" data-id="element-254">
            <PillIcon className="w-5 h-5 text-slate-400" data-id="element-255" />
            <ArrowRightIcon className="w-4 h-4 text-slate-500" data-id="element-256" />
            <div className="relative w-8 h-8 rounded-full bg-slate-800 border border-slate-600 flex items-center justify-center" data-id="element-257">
              <HelpCircleIcon className="w-4 h-4 text-slate-400" data-id="element-258" />
            </div>
          </div>
          <span className="text-xs font-medium text-slate-400" data-id="element-259">
            Indirect understanding
          </span>
        </motion.div>

        {/* Right Panel: Direct/Visible */}
        <motion.div initial={{
        opacity: 0,
        x: 10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} className="bg-[#4B9FE1]/5 border border-[#4B9FE1]/20 rounded-xl p-4 flex flex-col items-center text-center relative overflow-hidden" data-id="element-260">
          <div className="absolute inset-0 bg-gradient-to-b from-[#4B9FE1]/10 to-transparent opacity-50" data-id="element-261" />
          <div className="flex items-center justify-center space-x-2 mb-4 h-12 relative z-10" data-id="element-262">
            <PillIcon className="w-5 h-5 text-[#4B9FE1]" data-id="element-263" />
            <ArrowRightIcon className="w-4 h-4 text-[#4B9FE1]/70" data-id="element-264" />
            <motion.div animate={{
            boxShadow: ['0 0 0px rgba(75,159,225,0)', '0 0 20px rgba(75,159,225,0.6)', '0 0 0px rgba(75,159,225,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-8 h-8 rounded-full bg-[#4B9FE1]/20 border border-[#4B9FE1] flex items-center justify-center" data-id="element-265">
              <ActivityIcon className="w-4 h-4 text-[#4B9FE1]" data-id="element-266" />
            </motion.div>
          </div>
          <span className="text-xs font-medium text-[#4B9FE1] relative z-10" data-id="element-267">
            Imaging-enabled biological insight
          </span>
        </motion.div>
      </div>
    </div>;
}